import { render, staticRenderFns } from "./DeleteCompliance.vue?vue&type=template&id=5fbe41c5"
import script from "./DeleteCompliance.vue?vue&type=script&lang=js"
export * from "./DeleteCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports